export default __webpack_public_path__ + "media/images/menu-icon/auto-3a2d5e97900262507ae22564673361ac.png";